import { render } from "./ImportModal.vue?vue&type=template&id=72efd7f4&scoped=true"
import script from "./ImportModal.vue?vue&type=script&lang=js"
export * from "./ImportModal.vue?vue&type=script&lang=js"

import "./ImportModal.vue?vue&type=style&index=0&id=72efd7f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72efd7f4"]])

export default __exports__